<template>
  <v-switch class="app-switch"  :ripple="ripple" :input-value="inputValue" v-on="$listeners" v-bind="resetProps" />
</template>
<script>
export default {
  name: "BaseSwitch",
  props: {
    ripple: {
      type: Boolean,
      default: false,
    },
    inputValue: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    resetProps() {
      return { ...this.$attrs };
    },
  },
};
</script>

<style lang="scss">
.app-switch {
  width: 4.5rem;
  .v-input--switch__track {
    border-radius: 0.8rem;
    width: 3.6rem;
    height: 1.4rem;
    left: 0.2rem;
    position: absolute;
    opacity: 0.6;
    right: 0.2rem;
    top: calc(50% - 0.7rem);
  }

  .v-application--is-ltr .v-input--switch.v-input--is-dirty .v-input--selection-controls__ripple,
  .v-application--is-ltr .v-input--switch.v-input--is-dirty .v-input--switch__thumb {
    transform: translate(2rem, 0);
  }

  .v-application--is-ltr .v-input--selection-controls__input {
    margin-right: 0.8rem;
  }
}
</style>
